import { WeaTools } from 'ecCom';

export const getSuggestList = (params) => {
    return WeaTools.callApi('/api/hrm/group/getSearchResult', 'POST', params);
}

export const save = (params) => {
    return WeaTools.callApi('/api/hrm/group/save', 'POST', params);
}

export const del = (params) => {
    return WeaTools.callApi('/api/hrm/group/delete', 'POST', params);
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/apis/suggestDetail.js